module.exports = __webpack_public_path__ + "static/media/password.d5f6f33b.png";